import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import Experience from "../components/Experience";
import Skills from "../components/Skills";
import Projects from "../components/Projects";
import GetInTouch from "../components/GetInTouch";
import Footer from "../components/Footer";

const HomePage = () => {
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    document.documentElement.classList.add("dark");
    const handleScroll = () => {
      const sections = ["home", "about", "experience", "skills", "projects", "contact"];
      const y = window.scrollY + 140;
      for (let i = sections.length - 1; i >= 0; i--) {
        const el = document.getElementById(sections[i]);
        if (el && y >= el.offsetTop) { setActiveSection(sections[i]); break; }
      }
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-bg text-ink selection:bg-accent selection:text-bg">
      <Header activeSection={activeSection} />
      <main>
        <section id="home"><Hero /></section>
        <section id="about"><About /></section>
        <section id="experience"><Experience /></section>
        <section id="skills"><Skills /></section>
        <section id="projects"><Projects /></section>
        <section id="contact"><GetInTouch /></section>
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
